<template>
  <div v-if="show" class="langsx">
    <!-- <v-btn-toggle :value="currentLang" tile group>
      <v-btn v-for="lng in langs" :key="lng" :value="lng" @click="switchLang(lng)" text>{{ lng }}</v-btn>
    </v-btn-toggle> -->
    <v-select
      :items="langItems"
      :value="currentLang"
      :label="$t('lang')"
      outlined
      @change="switchLang($event)"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: 'LangSwitcher',
  props: {
    langs: Array
  },
  computed: {
    langItems () {
      return this.langs.map(l => ({
        text: this.$t(l),
        value: l
      }))
    },
    locale () {
      return this.$root.$i18n.locale
    },
    queryLang () {
      return this.$route.query.lang
    },
    lang () {
      return this.queryLang || this.locale
    },
    currentLang () {
      // the lang displayed - either by selection, or first as default
      return this.langs.indexOf(this.lang) > -1 ? this.lang : this.langs[0]
    },
    show () {
      // only show if there is a choice (>1)
      return this.langs && this.langs.length > 1
    }
  },
  methods: {
    switchLang (lang) {
      if (this.$root.$i18n.locales.includes(lang)) {
        // if lang also exists as app-lang, switch app lang, too
        this.$root.$i18n.setLocale(lang)
        this.$router.push({ query: null })
      } else {
        // else set content-lang in query param
        this.$router.push({ query: { lang: lang } })
      }
    }
  }
}
</script>

<style scoped>
.langs {
  text-align: center;
  margin-bottom: 10px;
}
.langs >>> .v-select {
  width: 120px;
  margin: 0 auto;
}
</style>
